import React, { useEffect, useState } from "react";
import ChartSidebarAccordion from "../ChartSidebarAccordion";
import { useSelector } from "react-redux";
import userActions from "../actions";
// import { useHistory } from "react-router";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "../Styles";
import CentralAZSidebarChart from "./CentralAZSidebarChart";
import ColoradoRiverAccessLocationFilter from "../ColoradoRiverAccessLocationFilter";
import { useHistory, useLocation } from "react-router";

function CentralAZMetrics({ metrics }) {
  const classes = useStyles();
  return (
    <Grid container>
      {metrics?.map((metric, idx) => (
        <Grid item xs={6} key={`${metric.value}_${idx}`}>
          <Typography
            variant="body2"
            component="p"
            className={classes.metricTitle}
          >
            {metric.label}
          </Typography>
          <Typography
            variant="h6"
            component="div"
            className={classes.metricValue}
          >
            {metric.value}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}

function CentralAZChartTab() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('type');
  const dropdown = params.get('dropdown');
  
  const {
    central_az_tab,
    irrigation_districts,
    irrigation_district_water_deliveries: district_deliveries,
    irrigation_district_selected,
    irrigation_district_water_use: district_use,
    city_selected,
    city_metrics,
    cities,
    western_arizona_entities,
  } = useSelector((state) => state.technical_view);

  const {
    setCentralAZTab,
    setSelectedCity,
    loadCityMetrics,
    setSelectedIrrigationDistrict,
    setIsTribe,
    setIsWesternEntity,
    setIsCity,
    setSelectedWesternArizonaEntity,
    setEntityHeader,
  } = userActions();

  const [city_metrics1, setCityMetrics] = useState(null);
  const [district_deliveries1, setDistrictDeliveries] = useState(null);
  const [district_use1, setDistrictUse] = useState(null);

  const history = useHistory();
  // const { loggedIn } = useSelector((state) => state.auth);
  const classes = useStyles();

  //Implemented the reverse logic where on changing URL path params - type and entity,
  // the pie chart and right side drawer updates accordingly
  const handleTabs = () => {
    if (tab === "irrigation_district" || tab === "cities") {
      setCentralAZTab(tab)
    }
    handleURLParamsChange(dropdown)
  }
  useEffect(handleTabs, [tab, dropdown, cities, irrigation_districts]);

  useEffect(() => {
      if (Object.keys(city_metrics).length > 0) {
      setCityMetrics(city_metrics);
    }
  }, [city_metrics]);
  useEffect(() => {
    if (Object.keys(district_deliveries).length > 0) {
      setDistrictDeliveries(district_deliveries);
    }
  }, [district_deliveries]);
  useEffect(() => {
    if (Object.keys(district_use).length > 0) {
      setDistrictUse(district_use);
    }
  }, [district_use]);
  const checkValid = (par) => {
    return (
      city_metrics1 !== null &&
      district_deliveries1 !== null &&
      district_use1 !== null
    );
  };
  const metrics = checkValid("metrics")
    ? {
        irrigation_district: [
          {
            label: "Municipal Tap Water",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.municipal_drinking?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Agriculture",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.agriculture?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Industry & Other Turf",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.industry_and_turfs?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "HOA & Homeowner Yards",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.hoa_homeowner_yards?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Schools & Parks",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.schools_parks?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Golf Courses",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.golf_courses.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Total Deliveries",
            value: `${district_deliveries[
              irrigation_district_selected.name
            ]?.district_total_deliveries.toLocaleString("en-US")} ac-ft`,
          },
        ],
        cities: [
          {
            label: "Turf Facilities",
            value: `${city_metrics.turf_total?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Recharge",
            value: `${city_metrics.aquifer_recharge_total?.toLocaleString(
              "en-US"
            )} ac-ft`,
          },
          {
            label: "Tap",
            value: `${city_metrics?.tap_total?.toLocaleString("en-US")} ac-ft`,
          },
          {
            label: "Agriculture (GSF)",
            value: `${city_metrics.agriculture_total?.toLocaleString(
              "en-US"
            )} ac-ft`,
          },
          {
            label: "Exchange",
            value: `${city_metrics.exchange_total?.toLocaleString(
              "en-US"
            )} ac-ft`,
          },
        ],
      }
    : {};


  const chartData = checkValid("chart")
    ? {
        irrigation_district: {
          categories: [
            "Colorado River",
            "Salt & Verde",
            "Groundwater",
            "Reclaimed Water",
            "Other River Water",
          ],
          data: [
            district_use[irrigation_district_selected.name]?.colorado_river,
            district_use[irrigation_district_selected.name]?.salt_and_verde,
            district_use[irrigation_district_selected.name]?.groundwater,
            district_use[irrigation_district_selected.name]?.reclaimed_water,
            district_use[irrigation_district_selected.name]?.other_river_water,
          ],
        },
        cities: {
          categories: [
            "Colorado River",
            "Salt & Verde",
            "Groundwater",
            "Agua Fria",
          ],
          data: [
            city_metrics.tap_colorado_num,
            city_metrics.tap_salt_and_verde_num,
            city_metrics.tap_groundwater_num,
            city_metrics.tap_agua_fria_num,
          ],
        },
      }
    : {};

    const handleURLParamsChange = (label) => {
      if (
        central_az_tab === "irrigation_district" &&
        Object.keys(irrigation_districts).length > 0
      ) {
        var irrigationFound = irrigation_districts.find((item) => item.label.toLowerCase() === (dropdown.toLowerCase()));
        setSelectedIrrigationDistrict(irrigationFound); //the irrigation_districts array index is 1 below the irrigation_district value
        setIsCity(false)
        setIsTribe(false);
        setIsWesternEntity(true);
      } else if (
        central_az_tab === "cities" &&
        Object.keys(cities).length > 0
      ) {
        var cityFound = cities.find((item) => item.label.toLowerCase() === (dropdown?.toLowerCase() || 'Phoenix'));
        /** Don't Mutate the Redux state when the cityFound is null/undefined */
        if(cityFound) {
          setSelectedCity(cityFound);
          loadCityMetrics(cityFound.value);
          setIsCity(true)
          setIsTribe(false);
          setIsWesternEntity(false);
        }
      }
    }

  const handleChange = (value) => {
    if (
      central_az_tab === "irrigation_district" &&
      Object.keys(irrigation_districts).length > 0
    ) {
      var irrigationFound = irrigation_districts.find((item) => item.value === (value));
      setSelectedIrrigationDistrict(irrigationFound); //the irrigation_districts array index is 1 below the irrigation_district value
      let westernAzEntity = western_arizona_entities?.find((item) => item?.label === irrigationFound?.label) // Irrigation district is a subset of western arizona entity
      if(westernAzEntity) {
        setSelectedWesternArizonaEntity(westernAzEntity)
      }

      setIsTribe(false);
      setIsCity(false)
      setIsWesternEntity(true);

      //Updated path params on selecting a new dropdown element or switching tabs
      history.push({
        pathname: `/visualizations/doughnut`,
        search:  "?" + new URLSearchParams({type: "irrigation_district", dropdown: irrigationFound.label}).toString()
      });

    } else if (
      central_az_tab === "cities" &&
      Object.keys(cities).length > 0
    ) {
      var cityFound = cities.find((item) => item.value === (value));
      //Updated path params on selecting a new dropdown element or switching tabs
      history.push({
        pathname: `/visualizations/doughnut`,
        search:  "?" + new URLSearchParams({type: "cities", dropdown: cityFound.label}).toString()
      });

      setSelectedCity(cityFound);
      loadCityMetrics(value);
      setIsTribe(false);
      setIsCity(true)
      setIsWesternEntity(false);
    }
  }

  const setHeader = () => {
    let city_id = central_az_tab === "irrigation_district"? irrigation_district_selected?.agriculture_id : city_selected?.city_id
    let location_options = central_az_tab === "irrigation_district" ? irrigation_districts : cities

    if(city_id && location_options?.length) {
      setEntityHeader(location_options, city_id)
    }
  }

  useEffect(setHeader, [central_az_tab, irrigation_districts])

  return (
    <>
      <ColoradoRiverAccessLocationFilter
          location_options={
            central_az_tab === "irrigation_district"
              ? irrigation_districts
              : cities
          }
          handleChange={handleChange}
          city_id={central_az_tab === "irrigation_district"? irrigation_district_selected.agriculture_id : city_selected.city_id}
          style={{ marginLeft: 26 }}
          autocomplete={true}
        />
      <Typography
        variant="body2"
        component="div"
        className={classes.metricSubTitle}
      >
        
      </Typography>
      <ChartSidebarAccordion
        group_name={
          central_az_tab === "irrigation_district"
            ? `${irrigation_district_selected.name} Water Uses - 2020`
            : `${city_selected.name} Water Uses - 2020`
        }
        accordion_name={'water_uses'}
      >
        {
          central_az_tab === "irrigation_district" || (Object.keys(city_metrics).length !== 0)?(
            <CentralAZMetrics metrics={metrics[central_az_tab]} />
          ):
          <Typography
            variant="body2"
            component="div"
            className={classes.metricSubTitle}
          >
          The {irrigation_district_selected.name} does not have an entitlement to Colorado River water but may receive Colorado River water from partners who deliver it to the irrigation district’s groundwater savings facility
          </Typography>
        }
        
      </ChartSidebarAccordion>
      <ChartSidebarAccordion
        group_name={
          central_az_tab === "irrigation_district"
            ? `${irrigation_district_selected.name} Water Uses - 2020`
            : `${city_selected.name} Tap Water Sources - 2020`
        }
        accordion_name={'water_sources'}
      > 
      {
        central_az_tab === "irrigation_district" || (Object.keys(city_metrics).length !== 0)?(
          <CentralAZSidebarChart chartData={chartData[central_az_tab]} />
        ):
        <Typography
          variant="body2"
          component="div"
          className={classes.metricSubTitle}
        >
          The {irrigation_district_selected.name} does not have an entitlement to Colorado River water but may receive Colorado River water from partners who deliver it to the irrigation district’s groundwater savings facility
        </Typography>
      }
        
        
      </ChartSidebarAccordion>
    </>
  );
}

export default CentralAZChartTab;
